import {
  LuActivity, LuCalendarRange, LuChartColumn, LuClock, LuFilter, LuLayers, LuLayoutGrid,
  LuLogOut, LuMonitorSmartphone, LuUsers,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('monitoring', '/admin/monitoring', 'admin_monitoring', [
    ['tabs', 'monitoring.tabs', LuActivity],
    ['kpis', 'monitoring.kpis', LuChartColumn, opt],
    ['modules', 'monitoring.modules', LuLayers, { placement: 'top', ...opt }],
  ]),

  tour('monitoring_presence', '/admin/monitoring/presence', 'admin_monitoring', [
    ['table', 'monitoring_presence.table', LuUsers],
    ['filters', 'monitoring_presence.filters', LuFilter],
  ], { exact: true }),

  tour('monitoring_activity', '/admin/monitoring/activity', 'admin_monitoring', [
    ['table', 'monitoring_activity.table', LuActivity, { placement: 'top' }],
    ['categories', 'monitoring_activity.categories', LuLayoutGrid],
    ['filters', 'monitoring_activity.filters', LuCalendarRange],
  ], { exact: true }),

  tour('monitoring_sessions', '/admin/monitoring/sessions', 'admin_monitoring', [
    ['table', 'monitoring_sessions.table', LuMonitorSmartphone],
    ['action', 'monitoring_sessions.action', LuLogOut, { placement: 'left' }],
  ], { exact: true }),

  tour('monitoring_last_seen', '/admin/monitoring/last-seen', 'admin_monitoring', [
    ['table', 'monitoring_last_seen.table', LuClock],
    ['filters', 'monitoring_last_seen.filters', LuFilter],
  ], { exact: true }),
];

export default tours;
